import React from 'react';
import formatUSD from '../../../utils/formatUSD';
import styled from 'styled-components';
import cart from '../../../utils/cart';

const PriceDisplay = styled.div`
  font-weight: 900;
`;

const QuantityNote = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #4a4a4a;
`;

const CartItemPrice = ({ cartItem }) => {
  const unitPrice = cart.determineCartItemPrice(cartItem);
  const quantity = cartItem.quantity || 1;
  const price = cart.cartLineTotal(cartItem);
  const explicit = cartItem.retouchingPricingMode === 'per_image';
  if (explicit && !cart.validRetouchingLinePrice(cartItem))
    return (
      <PriceDisplay>Price needs review. Please refresh your cart.</PriceDisplay>
    );
  const count = explicit ? cart.retouchingImageCount(cartItem) : 0;
  const units = explicit
    ? cart.marginalRetouchingPrices({
        basePriceCents: cartItem.price,
        scheduleCents: cartItem.retouchingTieredUnitPricesCents,
        count,
      })
    : [];
  const options = unitPrice - (cartItem.price || 0);
  const note = explicit
    ? `${count} image${count === 1 ? '' : 's'}: ${units
        .map((cents) => formatUSD(cents))
        .join(' + ')}${
        options ? ` + ${formatUSD(options)} options per image` : ''
      }`
    : `${formatUSD(unitPrice)} × ${quantity}`;

  return (
    <PriceDisplay>
      {price === 0 ? 'Free' : formatUSD(price)}
      {(explicit || quantity > 1) && <QuantityNote>{note}</QuantityNote>}
    </PriceDisplay>
  );
};

export default CartItemPrice;
